export default {
  searchKey: state => state.searchKey,
  activeTab: state => state.activeTab,
  tabs: state => state.tabs,
  activeMappingType: state => state.activeMappingType,

  business: state => state.business,

  loading: state => state.loading,
  businesses: state => state.businesses,
  distributors: state => state.distributors,
  salesReps: state => state.salesReps,
  vehicleManufacturers: state => state.vehicleManufacturers,
  insuranceCompanies: state => state.insuranceCompanies,
  products: state => state.products
}



// WEBPACK FOOTER //
// ./src/store/modules/business/getters.js